import classNames from 'classnames';
import PropTypes from 'prop-types';
import { IconClose } from '@medifind/icons';
import { Input } from '@medifind/shared-basic-components';
import { areFilterStatesEqual } from '@medifind/zustand';
import { Filter } from './Filter';
import styles from './FilterShared.module.scss';

const StoreFilterFieldInput = ({
  filter = {},
  onInputChange,
  classes = {},
  label = '',
  what,
  smallAt,
  placeholder,
  onValueClear,
  onValueSubmit,
  noHeader,
  isBar = false,
  autocomplete = 'off',
}) => {
  const { selected, getInitialState, reset } = filter;
  const handleInputChange = ({ target: { value } }) => {
    onInputChange && onInputChange(value);
  };

  const handleClearValue = () => {
    onValueClear && onValueClear();
  };

  const handleInputSubmit = (value) => {
    onValueSubmit && onValueSubmit(value);
  };
  return (
    <Filter
      classes={classes}
      label={label}
      what={what}
      smallAt={smallAt}
      noHeader={noHeader}
      onClear={() => {
        reset && reset();
        handleClearValue();
      }}
      isChanged={!areFilterStatesEqual(getInitialState(), filter)}
    >
      <Input
        onChange={handleInputChange}
        labelId={'-'} // Is replaced by <Filter>
        className={classNames({ [styles['input-container-override']]: !isBar })}
        classes={{ ...classes, input: classNames(classes.input, { [styles['input-override']]: !isBar }) }}
        label={label}
        value={selected ? selected : ''}
        placeholder={placeholder}
        onValueSubmit={handleInputSubmit}
        autocomplete={autocomplete}
        inputIcon={
          selected
            ? [
                {
                  icon: <IconClose size="medium" />,
                  onClick: handleClearValue,
                  label: 'Clear ' + (label ?? 'Field'),
                },
              ]
            : []
        }
      />
    </Filter>
  );
};

// label,
//   placeholder,
//   onChange,
//   classes,
//   className,
//   value,
//   initialValue,
//   onInputSubmit

StoreFilterFieldInput.propTypes = {
  filter: PropTypes.any.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  what: PropTypes.node,
  classes: PropTypes.object,
  label: PropTypes.string,
  smallAt: PropTypes.string,
  placeholder: PropTypes.string,
  onValueClear: PropTypes.func,
  onValueSubmit: PropTypes.func,
  noHeader: PropTypes.bool,
  isBar: PropTypes.bool,
  autocomplete: PropTypes.string,
};

export { StoreFilterFieldInput as default, StoreFilterFieldInput };
